import React from "react";
import "./Heading.css";
import images from "../../../../../../utilities/images/images";

const Heading = ({ title, onBack, darkMode }) => {
  return (
    <div className={`top-nav ${darkMode ? "dark" : "light"}`}>
      <img
        className="heading-back"
        src={images.BackArrow}
        onClick={onBack}
        alt="backarrow"
        style={{ cursor: "pointer" }}
      />
      <h1 className="nav-title">{title}</h1>
    </div>
  );
};

export default Heading;
